/**
 * Tabs de navegación entre las sub-rutas del módulo Finanzas.
 * Se renderiza en cabecera de cada sub-página (Resumen, Facturas, Liquidaciones,
 * Cobros, Comisiones, Informes) para que el usuario sienta UN solo módulo.
 */
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard, FileText, Building2, Wallet, Users, BarChart3,
} from 'lucide-react';

const ITEMS = [
  { path: '/crm/finanzas',                label: 'Resumen',         icon: LayoutDashboard },
  { path: '/crm/finanzas/facturas',       label: 'Facturas',        icon: FileText },
  { path: '/crm/finanzas/liquidaciones',  label: 'Liquidaciones B2B', icon: Building2 },
  { path: '/crm/finanzas/cobros',         label: 'Cobros y Pagos',  icon: Wallet },
  { path: '/crm/finanzas/comisiones',     label: 'Comisiones',      icon: Users },
  { path: '/crm/finanzas/informes',       label: 'Informes',        icon: BarChart3 },
];

export default function FinanzasNav() {
  const { pathname } = useLocation();
  const norm = pathname;
  return (
    <div className="border-b mb-4 -mt-2">
      <div className="flex gap-1 overflow-x-auto pb-1" data-testid="finanzas-nav">
        {ITEMS.map(({ path, label, icon: Icon }) => {
          const active =
            norm === path || (path !== '/crm/finanzas' && norm.startsWith(path));
          return (
            <Link
              key={path}
              to={path}
              className={cn(
                'inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-t-md whitespace-nowrap border-b-2 transition-colors',
                active
                  ? 'border-primary text-primary bg-primary/5'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
              )}
              data-testid={`finanzas-nav-${path.split('/').pop() || 'resumen'}`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
